module.exports = __webpack_public_path__ + "assets/img/16.8816253d.png";